import React, { useEffect, useRef, useState } from 'react';

const SubScroll = ({ children, dependency }) => {
    const scrollRef = useRef(null);
    const subScrollRef = useRef(null);
    const contentRef = useRef(null);

    const [hasOverflow, setHasOverflow] = useState(false);
    const [contentWidth, setContentWidth] = useState(0);

    const checkOverflow = () => {
        if (!scrollRef.current || !contentRef.current) return;

        const contentW = contentRef.current.scrollWidth;
        const containerW = scrollRef.current.clientWidth;

        setContentWidth(contentW);
        setHasOverflow(contentW > containerW);
    };

    useEffect(() => {
        checkOverflow();
        window.addEventListener("resize", checkOverflow);

        return () => window.removeEventListener("resize", checkOverflow);
    }, [dependency]);

    useEffect(() => {
        const timeout = setTimeout(checkOverflow, 50);
        return () => clearTimeout(timeout);
    }, [dependency]);

    useEffect(() => {
        if (!contentRef.current) return;

        const observer = new ResizeObserver(() => {
            checkOverflow();
        });

        observer.observe(contentRef.current);

        return () => observer.disconnect();
    }, []);

    const syncScroll = (e, isFake = false) => {
        if (!scrollRef.current || !subScrollRef.current) return;

        if (isFake) {
            scrollRef.current.scrollLeft = e.target.scrollLeft;
        } else {
            subScrollRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    return (
        <div className="overflow-x-hidden">
            <div ref={scrollRef} className="overflow-x-auto hide-scrollbar" onScroll={(e) => syncScroll(e)}>
                <div ref={contentRef}>
                    {children}
                </div>
            </div>

            {hasOverflow && (
                <div ref={subScrollRef} onScroll={(e) => syncScroll(e, true)} className="fixed bottom-0 left-0 w-full overflow-x-auto z-50">
                    <div style={{ width: contentWidth, height: 1 }} />
                </div>
            )}
        </div>
    );
};

export default SubScroll;